import { TABLE_SECTIONS } from "./config";
import { t, tf } from "../i18n";

const INQUIRY_STORAGE_KEY = "inquiry_products";

const getInquiryIds = () => {
  try {
    const items = JSON.parse(localStorage.getItem(INQUIRY_STORAGE_KEY));
    if (!Array.isArray(items)) return [];

    return items.map((item) => String(item.id));
  } catch {
    return [];
  }
};

const renderTextValue = (value) => value || "-";

const renderCertificates = (certificates = []) => {
  if (!Array.isArray(certificates) || !certificates.length) {
    return "-";
  }

  return `
    <div class="table__certificates">
      ${certificates
        .map(
          ({ url, alt, title }) => `
            <img
              class="table__certificate-image"
              src="${url}"
              alt="${alt || title || t("compareCertificateAlt", "Certyfikat")}"
              loading="lazy"
            >
          `,
        )
        .join("")}
    </div>
  `;
};

const renderCellContent = (product, row) => {
  if (row.type === "certificates") {
    return renderCertificates(product[row.key]);
  }

  return renderTextValue(product[row.key]);
};

const renderInquiryBadge = ({ id, title, isInInquiry }) => {
  if (!isInInquiry) return "";

  return `
    <label class="table__context-item table__context-item--checkbox table__context-item--checkbox-2" data-inquiry-badge>
      <input
        type="checkbox"
        class="table__context-checkbox checkbox"
        data-product-inquiry="${id}"
        data-product-title="${renderTextValue(title)}"
        checked
      >
      <span>${t("productsAddedToInquiry", "Dodane do zapytania")}</span>
    </label>
  `;
};

const renderHead = (products, inquiryIds) => {
  return products
    .map(
      ({ id, title, pdf = "", permalink = "#" }, index) => {
        const isInInquiry = inquiryIds.includes(String(id));

        return `
        <div class="table__head-cell ${isInInquiry ? "table__head-cell--query" : ""}" data-product-id="${id}">
 <div class="table__counter">
            ${tf("compareProductCounter", "Produkt %{count} z %{total}", {
              count: `<span>${index + 1}</span>`,
              total: products.length,
            })}
          </div>
          <h3 class="table__title">${renderTextValue(title)}</h3>

          ${renderInquiryBadge({ id, title, isInInquiry })}

          <div class="table__context-wrapper">
            <button
              type="button"
              class="table__context-btn"
              data-context-toggle
              aria-label="${tf("compareOpenProductMenu", "Otwórz menu produktu %{title}", {
                title: renderTextValue(title),
              })}"
              aria-expanded="false"
            >
              <img
                src="${themeUrl}/src/img/three-dots.svg"
                class="table__context-icon"
                alt=""
              >
            </button>

            <div class="table__context-menu" data-context-menu hidden>
              <label class="table__context-item table__context-item--checkbox">
                <input
                  type="checkbox"
                  class="table__context-checkbox checkbox"
                  data-product-inquiry="${id}"
                  data-product-title="${renderTextValue(title)}"
                  ${isInInquiry ? "checked" : ""}
                >
                <span>${t("productsAddToInquiry", "Dodaj do zapytania")}</span>
              </label>

              <a
                href="${permalink}"
                class="table__context-item"
              >
                <img
                  src="${themeUrl}/src/img/file-list-black.svg"
                  class="table__context-item-icon"
                  alt=""
                >
                <span>${t("productsCardLabel", "Karta produktu")}</span>
              </a>

              <button
                type="button"
                class="table__context-item"
                data-product-remove="${id}"
              >
                <img
                  src="${themeUrl}/src/img/close.svg"
                  class="table__context-item-icon"
                  alt=""
                >
                <span>${t("compareRemoveLabel", "Usuń z porównania")}</span>
              </button>
            </div>
          </div>
        </div>
      `;
      },
    )
    .join("");
  };

const renderRow = (products, row, inquiryIds) => {
  const cells = products
    .map(
      (product) => `
        <div class="table__cell ${inquiryIds.includes(String(product.id)) ? "table__cell--inquiry" : ""}" data-product-column-id="${product.id}">
          ${renderCellContent(product, row)}
        </div>
      `,
    )
    .join("");

  return `
    <div class="table__row table__row--label" data-row-key="${row.key}">
      <div class="table__label">${row.label}</div>
      <div class="table__row-data">${cells}</div>
    </div>
  `;
};

const renderSection = (products, section, inquiryIds) => `
  <div class="table__section-title">
    <span>${section.title}</span>
    
  </div>
  ${section.rows.map((row) => renderRow(products, row, inquiryIds)).join("")}
`;

const setControlsVisible = (isVisible) => {
  const controls = document.querySelector(".table-heading__controls");
  if (!controls) return;

  controls.hidden = !isVisible;
  controls.classList.toggle("table-heading__controls--hidden", !isVisible);
};

export const renderEmptyState = (container) => {
  const regranulatyUrl = window.themeSettings?.regranulatyUrl || `${window.location.origin}/regranulaty`;

  container.classList.add("table__wrapper--no-border");
  setControlsVisible(false);
  container.innerHTML = `
    <div class="comparison-empty">
      ${t("compareEmptyState", "Porównywarka jest pusta, dodaj produkty do porównania.")}
      <a class="button" href="${regranulatyUrl}">
        ${t("queryEmptyButton", "Zobacz nasze produkty")}
      </a>
    </div>
  `;
};

export const renderErrorState = (container) => {
  setControlsVisible(true);
  container.innerHTML = `
    <div class="comparison-error">
      ${t("compareErrorState", "Nie udało się załadować danych porównania.")}
    </div>
  `;
};

export const renderTable = (container, products) => {
  const inquiryIds = getInquiryIds();

  setControlsVisible(true);
  container.innerHTML = `
    <div class="table">
      <div class="table__head">
        ${renderHead(products, inquiryIds)}
      </div>

      ${TABLE_SECTIONS.map((section) => renderSection(products, section, inquiryIds)).join("")}
    </div>
  `;

  // mark wrapper with number of columns so CSS can adjust mobile width
  try {
    const cols = Math.min(Math.max((products && products.length) || 0, 1), 4);
    container.classList.remove('table__wrapper--cols-1', 'table__wrapper--cols-2', 'table__wrapper--cols-3', 'table__wrapper--cols-4');
    container.classList.add(`table__wrapper--cols-${cols}`);
  } catch (e) {
    // noop
  }
};